import BadgePill from './BadgePill';

export default BadgePill;
